var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"hint"},[_vm._v(_vm._s(_vm.$t('profile.hint')))]),_c('div',{staticClass:"wrapper"},[_c('Form')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }